import { render, staticRenderFns } from "./AssetPreviewItem.vue?vue&type=template&id=99f9e488&scoped=true"
import script from "./AssetPreviewItem.vue?vue&type=script&lang=js"
export * from "./AssetPreviewItem.vue?vue&type=script&lang=js"
import style0 from "./AssetPreviewItem.vue?vue&type=style&index=0&id=99f9e488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f9e488",
  null
  
)

export default component.exports